import React from 'react';
import { Zap, XCircle, CheckCircle } from 'lucide-react';
export function OriginStory() {
  return <section className="bg-forest-50 py-20 px-4" data-id="element-122">
      <div className="max-w-4xl mx-auto" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <h2 className="text-3xl md:text-5xl font-bold text-forest-900" data-id="element-125">
            El Mecanismo que Cambia Todo:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-126">
          {/* Conventional Method */}
          <div className="bg-white p-8 rounded-3xl shadow-md border border-forest-800/10" data-id="element-127">
            <div className="flex items-center space-x-3 mb-6" data-id="element-128">
              <XCircle className="w-8 h-8 text-pain" data-id="element-129" />
              <h3 className="text-2xl font-bold text-forest-900" data-id="element-130">
                MÉTODO CONVENCIONAL
              </h3>
            </div>
            <ul className="space-y-4 text-lg text-forest-800 font-medium" data-id="element-131">
              <li className="flex items-center space-x-3" data-id="element-132">
                <span className="text-pain" data-id="element-133">→</span>
                <span data-id="element-134">Eliminar alimentos</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-135">
                <span className="text-pain" data-id="element-136">→</span>
                <span data-id="element-137">Restricción</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-138">
                <span className="text-pain" data-id="element-139">→</span>
                <span data-id="element-140">Antojo</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-141">
                <span className="text-pain" data-id="element-142">→</span>
                <span data-id="element-143">Abandono</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-144">
                <span className="text-pain" data-id="element-145">→</span>
                <span className="font-bold text-pain" data-id="element-146">SIBO vuelve</span>
              </li>
            </ul>
          </div>

          {/* SIBO Protocol */}
          <div className="bg-forest-900 p-8 rounded-3xl shadow-xl border-2 border-gold-400 text-white" data-id="element-147">
            <div className="flex items-center space-x-3 mb-6" data-id="element-148">
              <CheckCircle className="w-8 h-8 text-solution" data-id="element-149" />
              <h3 className="text-2xl font-bold text-gold-400" data-id="element-150">
                PROTOCOLO RESCATE SIBO™
              </h3>
            </div>
            <ul className="space-y-4 text-lg font-medium" data-id="element-151">
              <li className="flex items-center space-x-3" data-id="element-152">
                <span className="text-solution" data-id="element-153">→</span>
                <span data-id="element-154">Entender el mecanismo</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-155">
                <span className="text-solution" data-id="element-156">→</span>
                <span data-id="element-157">Eliminar el combustible del SIBO</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-158">
                <span className="text-solution" data-id="element-159">→</span>
                <span data-id="element-160">Restaurar el MMC</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-161">
                <span className="text-solution" data-id="element-162">→</span>
                <span data-id="element-163">Reparar la mucosa</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-164">
                <span className="text-solution" data-id="element-165">→</span>
                <span className="font-bold text-solution" data-id="element-166">
                  Libertad digestiva
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-167">
          <p className="text-xl md:text-2xl text-forest-800 italic font-medium" data-id="element-168">
            "En lugar de pelear contra tu intestino... le damos exactamente lo
            que necesita para sanar."
          </p>
        </div>
      </div>
    </section>;
}